import { render, staticRenderFns } from "./NewProjectForm.vue?vue&type=template&id=eff3fa4c&scoped=true"
import script from "./NewProjectForm.vue?vue&type=script&lang=js"
export * from "./NewProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff3fa4c",
  null
  
)

export default component.exports